import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addVoucherApi, deleteVoucherApi, getAllVoucherApi } from "@/api/voucher";
import { deleteConcessionApi, getAllConcessionApi } from "@/api/concession";

// Thunks
export const fetchConcessions = createAsyncThunk(
  "concession/fetchAll",
  async ({ restaurant_id, page = 1, search = "", status = "", per_page = 10 }, { rejectWithValue }) => {
    const query = `per_page=${per_page}${!search && `&page=${page}`}${
      search ? `&search_term=${search}` : ""
    }${status ? `&status=${status}` : ""}`;
    
    const res = await getAllConcessionApi(restaurant_id, query);
    
    if (res.status === "success") {
      return { ...res.data, search };
    }
    return rejectWithValue(res.message);
  }
);

export const deleteConcessionById = createAsyncThunk(
  "voucher/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteConcessionApi(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State
const initialState = {
  vouchers: [],
  singleVoucherCard: null,
  totalPages: 1,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
  search: "",
  status:"",
  perPage: 10,
  currentPage: 1
};

// Slice
const ConcessionSlice = createSlice({
  name: "voucher",
  initialState,
  reducers: {
    clearVoucherMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
      state.totalPages = 1;
      state.search = "";
    },
    setVoucherSearch: (state, action) => {
      state.search = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchConcessions.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchConcessions.fulfilled, (state, action) => {
        state.getLoading = false;
        state.vouchers = action.payload.concession_treats;
        state.requestStatus = true;
        state.totalPages = action.payload.pagination.last_page;
      })
      .addCase(fetchConcessions.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })
      // Delete
      .addCase(deleteConcessionById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteConcessionById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.vouchers = state.vouchers.filter(
          (voucher) => voucher.id !== action.payload
        );
        state.success = "Voucher deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteConcessionById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearVoucherMessages, setVoucherSearch, setStatus, setPerPage, setCurrentPage } = ConcessionSlice.actions;
export default ConcessionSlice.reducer;
